import { Typography } from "@material-ui/core"
import './TitleBlock.scss'
import DynamicHtml from "../../molecules/DynamicHtml"
const TitleBlock = ({ title, subtitle }: any) => {
    return <div className="titleBlock">
        <Typography variant='h6' color='textPrimary' className="title" noWrap={false} align='center'>
            <DynamicHtml content={title} />
        </Typography>
        {subtitle && <Typography variant='body2' color='textPrimary' className="sub_title" noWrap={false} align='center'>
            <DynamicHtml content={subtitle} />
        </Typography>}
    </div>
}

export default TitleBlock